import TopicService from '@/services/TopicService';
import { normalizeTopic } from '@/utils';

export const state = () => ({
  list: [],
  topicListType: 'all', // 'all' 'deleted' 'waiting'
  isMerging: false,
  mergeList: [],
  searchText: '',
  pagination: {
    page: 1,
    perPage: 50,
    total: 0
  }
});

export const getters = {
  list: (state) => state.list,
  pagination: (state) => state.pagination,
  mergeList: (state) => state.mergeList,
  isMerging: (state) => state.isMerging,
  currentState: (state) => {
    let statesType = {
      all: false,
      deleted: false,
      waiting: false,
      approved: false,
      restored: false
    };
    statesType[state.topicListType] = true;
    return statesType;
  }
};

export const mutations = {
  setPagination(state, payload) {
    state.pagination = {
      page: payload.page || state.pagination.page,
      perPage: payload.perPage || state.pagination.perPage,
      total: payload.total || state.pagination.total
    };
  },
  setList(state, payload) {
    state.list = payload;
  },
  setMergeList(state, payload) {
    state.mergeList = payload;
  },
  setIsMerging(state, payload) {
    state.isMerging = payload;
  },
  setTopicListType(state, payload) {
    state.topicListType = payload;
  },
  setSearchText(state, payload) {
    state.searchText = payload;
  }
};

export const actions = {
  async approveTopic({ state, dispatch }, id) {
    const result = await TopicService.approve(id);
    dispatch('getTopics', state.topicListType);
    return result;
  },
  async deleteTopic({ state, dispatch }, id) {
    const result = await TopicService.delete(id);
    dispatch('getTopics', state.topicListType);
    return result;
  },
  async restoreTopic({ state, dispatch }, id) {
    const result = await TopicService.restore(id);
    dispatch('getTopics', state.topicListType);
    return result;
  },
  async searchTopic({ commit }, payload) {
    const result = await TopicService.search(payload);
    const list = result.map((item) => item._source).map(normalizeTopic);
    commit('setList', list);
    return result;
  },
  async setListFromMerge({ commit, state }) {
    commit('setList', state.mergeList);
  },
  async setListFromSearch({ commit, state }) {
    commit('setList', state.searchList);
  },
  async allTopics({ commit }) {
    const result = await TopicService.all();
    commit('setList', result);
  },
  async allTopicsByType({ commit }, type) {
    const result = await TopicService.allByType(type);
    commit('setList', result);
  },
  async mergeTopics({ commit }, payload) {
    const result = await TopicService.merge(payload);
    normalizeTopic(result);
    commit('setList', [result]);
  },
  async updateTopic({ state, dispatch }, payload) {
    const result = await TopicService.update(payload);
    normalizeTopic(result);
    dispatch('getTopics', state.topicListType);
    return result;
  },
  async getTopics({ rootState, commit }, type) {
    commit('setIsMerging', false);
    commit('setTopicListType', type);
    let result = {};
    const query = rootState.route.query;
    if (rootState.route.query.search) {
      result = await TopicService.search(query);
      result.data = result.data.map(normalizeTopic);
    } else {
      result = await TopicService.allByType({ type, ...query });
      result.data.map(normalizeTopic);
    }
    // TODO: Backend should return approved topics
    if (type == 'approved') {
      result.data = result.data.filter((item) => item.approved && !item.deleted);
    }
    commit('setPagination', { total: result.count });
    commit('setList', result.data);
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
